import React, { useEffect, useState,useRef } from "react";
import Backdrop from "../../asserts/CRMbg.png";
import { ConfigProvider, Popover, Select, Cascader,Tooltip } from "antd";
import { LiaSearchSolid } from "react-icons/lia";
import { BsExclamationCircle } from "react-icons/bs";
import { MdCancel } from "react-icons/md";
import { IoMdArrowDropdown } from "react-icons/io";
import { FaPlus } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import Home from "./Home/Home";
import Credentials from "./Credentials/Credentials";
import CredentialForm from "./Credentials/CredentialForm";
import Documents from "./Documents/Documents";
import Contacts from "./Contacts/Contacts";
import ModalPopup from "../Common/Modal/Modal";
import "../../App.css";
import VaultLoginPage from "./VaultLogin/VaultLoginPage";
import { BiLogOutCircle } from "react-icons/bi";
import {
  AdminVaultAuthMe,
  AdminVaultLogout,
  AdminVaultLogoutAll,
} from "../../Api/SuperAdminVault/VaultLoginApi";
import { BsList, BsGrid } from "react-icons/bs";
import DocumentForm from "./Documents/DocumentForm";
import ContactForm from "./Contacts/ContactForm";
import LogBook from "./LogBook/LogBook";
import { GetCredentialsData } from "../../Api/SuperAdminVault/Credentials";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { GetAllCategoryDropdown, GetDocumentsData } from "../../Api/SuperAdminVault/Documents";

const SuperAdminVault = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("home");
  const [searchValue, setSearchValue] = useState("");
  const [credentialType, setCredentialType] = useState("");
  const [credentialModalOpen, setCredentialModalOpen] = useState(false);
  const [credentialModalMode, setCredentialModalMode] = useState("add");
  const [credentialId, setCredentialId] = useState(null);
  const [credentialRefreshKey, setCredentialRefreshKey] = useState(0);
  const [isVaultAuthenticated, setIsVaultAuthenticated] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otpPurpose, setOtpPurpose] = useState("");
  const [verified, setVerified] = useState(false);
  // Documents states
const [documentType, setDocumentType] = useState("");
const [documentCategoryValue, setDocumentCategoryValue] = useState([]);
const [documentCategoryFilter, setDocumentCategoryFilter] = useState({
  category_id: "",
  subcategory_id: "",
});

const [documentCategoryDropdown, setDocumentCategoryDropdown] = useState([]);
  const [documentView, setDocumentView] = useState("list"); // "list" | "grid"
  const [documentModalOpen, setDocumentModalOpen] = useState(false);
  const [documentModalMode, setDocumentModalMode] = useState("add");
  const [documentId, setDocumentId] = useState(null);
  const [documentRefreshKey, setDocumentRefreshKey] = useState(0);

  //Contacts states
  const [contactCategory, setContactCategory] = useState("");
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [contactModalMode, setContactModalMode] = useState("add");
  const [contactId, setContactId] = useState(null);
  const [contactRefreshKey, setContactRefreshKey] = useState(0);

  const [logType, setLogType] = useState("activity_logs");

  const tabs = [
    { key: "home", label: "Home" },
    { key: "credentials", label: "Credentials" },
    { key: "documents", label: "Documents" },
    { key: "contacts", label: "Contacts" },
    { key: "logs", label: "LogBook" },
  ];

  const searchInfoMap = {
    credentials: [
      { title: "Name" },
      { title: "Type" },
      { title: "Owner" },
      // { title: "Username" },
      // { title: "Updated Date" },
      // { title: "Expires Date" },
    ],
    documents: [
      { title: "Document Name" },
      // { title: "File Type" },
      // { title: "Description" },
      // { title: "Updated Date" },
      // { title: "Expires Date" },
    ],
    contacts: [
      { title: "Contact Name" },
      { title: "Designation" },
      {title: "Organisation"},
      // { title: "Email" },
      // { title: "Phone Number" },
      // { title: "Company" },
    ],
    logs: [
      { title: "User" },
      { title: "Action" },
      { title: "Module" },
      // { title: "Date" },
    ],
  };

  const currentSearchInfos = searchInfoMap[activeTab] || [];
  const isSearchDisabled = activeTab === "home" || activeTab === "logs";



const fetchDocumentCategoryDropdown = async () => {
  try {
    const response = await GetAllCategoryDropdown({});
   console.log(response?.data,"responsedd");
   
    const list = Array.isArray(response?.data) ? response.data : [];

    setDocumentCategoryDropdown(list);
  } catch (error) {
    console.error("Error fetching document category dropdown:", error);
  }
};

useEffect(() => {
  if (activeTab === "documents") {
    fetchDocumentCategoryDropdown();
  }

}, [activeTab]);

const EllipsisTooltip = ({
  text = "",
  className = "",
  placement = "right",
  enableTooltip = true,
}) => {
  const textRef = useRef(null);
  const [isEllipsis, setIsEllipsis] = useState(false);

  useEffect(() => {
    const checkEllipsis = () => {
      const element = textRef.current;

      if (!element) return;

      setIsEllipsis(element.scrollWidth > element.clientWidth);
    };

    checkEllipsis();

    window.addEventListener("resize", checkEllipsis);

    return () => {
      window.removeEventListener("resize", checkEllipsis);
    };
  }, [text]);

  const content = (
    <span
      ref={textRef}
      className={`block overflow-hidden text-ellipsis whitespace-nowrap ${className}`}
    >
      {text}
    </span>
  );

  if (!enableTooltip || !isEllipsis) {
    return content;
  }

  return (
    <Tooltip title={text} placement={placement}>
      {content}
    </Tooltip>
  );
};
const isLongText = (text = "") => String(text).length > 9;

const shortText = (text = "") => {
  const value = String(text);
  return value.length > 9 ? `${value.slice(0, 9)}...` : value;
};

const renderTooltipText = (text, className = "") => {
  const value = String(text || "");

  return (
    <EllipsisTooltip
      text={value}
      className={className}
      placement="right"
      enableTooltip={true}
    />
  );
};
const [documentCategoryOpen, setDocumentCategoryOpen] = useState(false);
const [expandedCategoryId, setExpandedCategoryId] = useState(null);
const [documentCategorySearch, setDocumentCategorySearch] = useState("");
const selectedCategoryId = documentCategoryValue?.[0] || "all";
const selectedSubCategoryId = documentCategoryValue?.[1] || "";

const selectedCategory = documentCategoryDropdown.find(
  (cat) => String(cat.category_id) === String(selectedCategoryId)
);

const selectedSubCategory = selectedCategory?.subcategories?.find(
  (sub) => String(sub.subcategory_id) === String(selectedSubCategoryId)
);

const selectedDocumentCategoryLabel =
  selectedCategoryId === "all"
    ? "All Category"
    : selectedSubCategory?.subcategory_name ||
      selectedCategory?.category_name ||
      "All Category";

const selectedDocumentCategoryKey = selectedSubCategoryId
  ? `sub-${selectedSubCategoryId}`
  : selectedCategoryId !== "all"
  ? `cat-${selectedCategoryId}`
  : "all";

const searchText = documentCategorySearch.trim().toLowerCase();

const filteredDocumentCategories = documentCategoryDropdown
  .map((category) => {
    const subcategories = Array.isArray(category.subcategories)
      ? category.subcategories
      : [];

    const categoryMatch = category.category_name
      ?.toLowerCase()
      .includes(searchText);

    const filteredSubcategories =
      !searchText || categoryMatch
        ? subcategories
        : subcategories.filter((sub) =>
            sub.subcategory_name?.toLowerCase().includes(searchText)
          );

    if (!searchText || categoryMatch || filteredSubcategories.length > 0) {
      return {
        ...category,
        subcategories: filteredSubcategories,
      };
    }

    return null;
  })
  .filter(Boolean);

  const openCredentialModal = (mode, id = null) => {
    setCredentialModalMode(mode);
    setCredentialId(id);
    setCredentialModalOpen(true);
  };

  const closeCredentialModal = () => {
    setCredentialModalOpen(false);
    setCredentialModalMode("add");
    setCredentialId(null);
  };

  const handleCredentialSuccess = () => {
    setCredentialRefreshKey((prev) => prev + 1);
  };

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    setSearchValue("");
    setCredentialType("");
    setDocumentType("");
setDocumentCategoryValue([]);
setDocumentCategoryFilter({
  category_id: "",
  subcategory_id: "",
});
    setContactCategory("");
    setLogType("activity_logs");
  };

  const handleClear = () => {
    setSearchValue("");
  };

  const handleKeyDown = (e) => {
    const isControlKey = [
      "Backspace",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
    ].includes(e.key);

    if (isControlKey) return;

    if (!/^[A-Za-z0-9\s@._\-*]$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case "credentials":
        return (
          <Credentials
            searchValue={searchValue}
            typeFilter={credentialType}
            refreshKey={credentialRefreshKey}
            openCredentialModal={openCredentialModal}
            otpPurpose={otpPurpose}
            setOtpPurpose={setOtpPurpose}
            verified={verified}
            setVerified={setVerified}
          />
        );

      case "documents":
        return (
          <Documents
  searchValue={searchValue}
  typeFilter={documentType}
  categoryFilter={documentCategoryFilter}
  viewMode={documentView}
  refreshKey={documentRefreshKey}
  openDocumentModal={openDocumentModal}
/>
        );

      case "contacts":
        return (
          <Contacts
            searchValue={searchValue}
            categoryFilter={contactCategory}
            refreshKey={contactRefreshKey}
            openContactModal={openContactModal}
          />
        );
      case "logs":
        return <LogBook typeFilter={logType} />;
      default:
        return <Home setActiveTab={setActiveTab} />;
    }
  };

  // Document modal handlers
  const openDocumentModal = (mode, id = null) => {
    setDocumentModalMode(mode);
    setDocumentId(id);
    setDocumentModalOpen(true);
  };

const clearDocumentFilters = () => {
  setDocumentType("");
  setDocumentCategoryValue(["all"]);
  setDocumentCategoryFilter({
    category_id: "",
    subcategory_id: "",
  });
  setExpandedCategoryId(null);
  setDocumentCategorySearch("");
  setDocumentCategoryOpen(false);
};

const closeDocumentModal = () => {
  setDocumentModalOpen(false);
  setDocumentModalMode("add");
  setDocumentId(null);
  clearDocumentFilters();
  fetchDocumentCategoryDropdown();
  GetDocumentsData({
    dispatch,
    page: 1,
    limit: 10,
    sort_order: "D",
    sort_column: "document_id",
    type_filter: "",
    search: "",
    category_id: "",
    subcategory_id: "",
  });
};

const handleDocumentSuccess = () => {
  setDocumentRefreshKey((prev) => prev + 1);
  fetchDocumentCategoryDropdown();
};

  // Contact modal handlers
  const openContactModal = (mode, id = null) => {
    setContactModalMode(mode);
    setContactId(id);
    setContactModalOpen(true);
  };

  const closeContactModal = () => {
    setContactModalOpen(false);
    setContactModalMode("add");
    setContactId(null);
  };

  const handleContactSuccess = () => {
    setContactRefreshKey((prev) => prev + 1);
  };

  const closeLogoutModal = () => {
    setShowLogoutModal(false);
  };

  const handleLogOut = async () => {
    console.log("logout run");

    await AdminVaultLogout();
    setIsVaultAuthenticated(false);
    setShowLogoutModal(false);
  };

  const handleLogOutAll = async () => {
    await AdminVaultLogoutAll();
    setIsVaultAuthenticated(false);
    setShowLogoutModal(false);
  };

  useEffect(() => {
    return () => {
      if (location.pathname === "/superadminvault") {
        console.log("log out useEffect triggered");
        AdminVaultLogout();
      }
    };
    //   if (location.pathname !== "/superadminvault") {
    //   console.log("navigated away from admin vault");
    //   AdminVaultLogout();
    // }
  }, [location.pathname]);
  //location.pathname

  useEffect(() => {
    const handleSessionExpired = () => {
      console.log("vault-session-expired EVENT RECEIVED");
      setIsVaultAuthenticated(false);
    };
    window.addEventListener("vault-session-expired", handleSessionExpired);
    console.log("vault-session-expired");

    return () =>
      window.removeEventListener("vault-session-expired", handleSessionExpired);
  }, []);
  useEffect(() => {
    const checkSession = async () => {
      // try {
      const authMe = AdminVaultAuthMe(setIsVaultAuthenticated, setLoading);
      // console.log(authMe,"aaaaaaaaaaaa");
      //   await GetCredentialsData({ dispatch, page: 1, limit: 1 });
      //   setIsVaultAuthenticated(true);
      // } catch {
      //   setIsVaultAuthenticated(false);
      // }
    };
    checkSession();
  }, []);
  const renderRightActions = () => {
    if (activeTab === "credentials") {
      return (
        <div className="flex items-center gap-[0.75vw]">
          <div className="umselect">
            <ConfigProvider
              theme={{
                components: {
                  Select: {
                    optionActiveBg: "#aebed1",
                    optionSelectedColor: "#FFF",
                    optionSelectedBg: "#e5e5e5",
                  },
                },
              }}
            >
              <Select
                showSearch
                value={credentialType}
                dropdownClassName="custom-dropdown"
                className="custom-select bg-white outline-none w-[11vw] h-[5vh] text-[1.1vw] border-[#1F487C] border-l-[0.1vw] border-t-[0.1vw] rounded-[0.75vw] border-r-[0.25vw] border-b-[0.25vw]"
                placeholder="All types"
                optionFilterProp="search"
                listHeight={200}
                dropdownStyle={{
                   width: "9vw",
                   padding: 0,
                   maxHeight: "25vw",
                   overflow: "hidden",
                }}
                onChange={(value) => setCredentialType(value)}
                suffixIcon={
                  <span style={{ fontSize: "1vw", color: "#1f487c" }}>
                    <IoMdArrowDropdown size="2vw" />
                  </span>
                }
                style={{ padding: 4 }}
                options={[
                  {
                    value: "",
                    label: <div>All types</div>,
                    search: "All types",
                  },
                  {
                    value: "api_key",
                    label: <div>API Key</div>,
                    search: "API Key",
                  },
                  {
                    value: "login",
                    label: <div>Login</div>,
                    search: "Login",
                  },
                  {
                    value: "database",
                    label: <div>Database</div>,
                    search: "Database",
                  },
                  {
                    value: "cloud",
                    label: <div>Cloud</div>,
                    search: "Cloud",
                  },
                  {
                    value: "token",
                    label: <div>Token</div>,
                    search: "Token",
                  },
                ]}
              />
            </ConfigProvider>
          </div>

          <button
            className="bg-[#1F487C] flex items-center justify-center gap-[0.5vw] h-[5vh] px-[1.25vw] rounded-[0.5vw] border-[#1F487C] border-l-[0.1vw] border-t-[0.1vw] border-r-[0.25vw] border-b-[0.25vw] text-white text-[1.1vw] font-bold"
            onClick={() => openCredentialModal("add")}
          >
            <FaPlus size="1vw" />
            Add Credential
          </button>
        </div>
      );
    }

    if (activeTab === "documents") {
      return (
        <div className="flex items-center gap-[0.50vw]">
          {/*Category Filter */}
<div className="umselect">
<ConfigProvider
  theme={{
    components: {
      Select: {
        optionSelectedBg: "#e5e5e5",
        optionSelectedColor: "#1F487C",
        optionActiveBg: "#aebed1",
      },
    },
  }}
>
  <Select
    showSearch
    labelInValue
    open={documentCategoryOpen}
    onDropdownVisibleChange={(open) => {
      setDocumentCategoryOpen(open);

      if (!open) {
        setDocumentCategorySearch("");
      }
    }}
    searchValue={documentCategorySearch}
    onSearch={setDocumentCategorySearch}
    filterOption={false}
    style={{
  paddingLeft: "0.35vw",
  paddingRight: "0.2vw",
}}
dropdownStyle={{
  width: "9vw",
  padding: 0,
  maxHeight: "25vw",
  overflow: "hidden",

}}
   value={{
  value: selectedDocumentCategoryKey,
  label: (
    <>
      {selectedCategoryId !== "all" &&
      isLongText(selectedDocumentCategoryLabel) ? (
        <Tooltip title={selectedDocumentCategoryLabel} placement="bottom">
          <span className="block max-w-[6.4vw] overflow-hidden text-ellipsis whitespace-nowrap text-[#1F487C]">
            {selectedDocumentCategoryLabel}
          </span>
        </Tooltip>
      ) : (
        <span className="block max-w-[6.4vw] overflow-hidden text-ellipsis whitespace-nowrap text-[#1F487C]">
          {selectedDocumentCategoryLabel}
        </span>
      )}
    </>
  ),
}}
    options={[
      {
        value: selectedDocumentCategoryKey,
        label: selectedDocumentCategoryLabel,
      },
    ]}
    dropdownClassName="custom-dropdown"
   className="custom-select bg-white outline-none w-[9vw] h-[5vh] text-[1.1vw] border-[#1F487C] border-l-[0.1vw] border-t-[0.1vw] rounded-[0.75vw] border-r-[0.25vw] border-b-[0.25vw]"
     placeholder="All Category"
    suffixIcon={
      <span style={{ fontSize: "1vw", color: "#1f487c" }}>
        <IoMdArrowDropdown size="2vw" />
      </span>
    }
dropdownRender={() => (
  <div className="max-h-[25vw] overflow-y-auto py-[0.35vw]">

    <div
      className={`mx-[0.3vw] mb-[0.1vw] cursor-pointer rounded-[0.35vw] px-[0.6vw] py-[0.35vw] text-[0.85vw] text-[#1F487C] hover:bg-[#aebed1] ${
        selectedCategoryId === "all" ? "bg-[#e5e5e5]" : ""
      }`}
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onClick={() => {
        setDocumentCategoryValue(["all"]);
        setDocumentCategoryFilter({
          category_id: "",
          subcategory_id: "",
        });
        setExpandedCategoryId(null);
        setDocumentCategorySearch("");
        setDocumentCategoryOpen(false);
      }}
    >
      All Category
    </div>

    {filteredDocumentCategories.map((category) => {
      const categoryId = String(category.category_id);
      const subcategories = Array.isArray(category.subcategories)
        ? category.subcategories
        : [];
      const hasSubCategory = subcategories.length > 0;
      const isExpanded = expandedCategoryId === categoryId;
      const isCategorySelected =
        selectedCategoryId === categoryId && !selectedSubCategoryId;

      return (
        <div key={categoryId}>
          <div
            className={`mx-[0.3vw] mb-[0.1vw] flex cursor-pointer items-center justify-between rounded-[0.35vw] px-[0.6vw] py-[0.35vw] text-[0.85vw] text-[#1F487C] hover:bg-[#aebed1] ${
              isCategorySelected ? "bg-[#e5e5e5]" : ""
            }`}
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onClick={() => {
              setDocumentCategoryValue([categoryId]);
              setDocumentCategoryFilter({
                category_id: categoryId,
                subcategory_id: "",
              });
              if (hasSubCategory) {
                setExpandedCategoryId((prev) =>
                  prev === categoryId ? null : categoryId
                );
              } else {
                setDocumentCategoryOpen(false);
              }
            }}
          >
            {renderTooltipText(category.category_name, "max-w-[6.5vw]")}
            {hasSubCategory && (
              <IoMdArrowDropdown
                size="1.1vw"
                className={`text-[#9CA3AF] transition-transform ${
                  isExpanded ? "rotate-180" : ""
                }`}
              />
            )}
          </div>

          {hasSubCategory && isExpanded && (
            <div>
              {subcategories.map((sub) => {
                const subCategoryId = String(sub.subcategory_id);
                const isSubCategorySelected =
                  selectedSubCategoryId === subCategoryId;

                return (
                  <div
                    key={subCategoryId}
                    className={`mx-[0.3vw] mb-[0.1vw] cursor-pointer rounded-[0.35vw] pl-[1.5vw] pr-[0.6vw] py-[0.35vw] text-[0.85vw] text-[#1F487C] hover:bg-[#aebed1] ${
                      isSubCategorySelected ? "bg-[#e5e5e5]" : ""
                    }`}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onClick={() => {
                      setDocumentCategoryValue([categoryId, subCategoryId]);
                      setDocumentCategoryFilter({
                        category_id: categoryId,
                        subcategory_id: subCategoryId,
                      });
                      setDocumentCategorySearch("");
                      setDocumentCategoryOpen(false);
                    }}
                  >
                    {renderTooltipText(sub.subcategory_name, "max-w-[6vw]")}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      );
    })}
  </div>
)}
  />
</ConfigProvider>
</div>
          {/* Type filter dropdown */}
          <div className="umselect">
            <ConfigProvider
              theme={{
                components: {
                  Select: {
                    optionActiveBg: "#aebed1",
                    optionSelectedColor: "#FFF",
                    optionSelectedBg: "#e5e5e5",
                  },
                },
              }}
            >
          <Select
  showSearch
  value={documentType}
  dropdownClassName="custom-dropdown"
  className="custom-select bg-white outline-none w-[9vw] h-[5vh] text-[1.1vw] border-[#1F487C] border-l-[0.1vw] border-t-[0.1vw] rounded-[0.75vw] border-r-[0.25vw] border-b-[0.25vw]"
  placeholder="All Types"
  optionFilterProp="search"
  virtual={false}
  dropdownStyle={{ maxHeight: "25vw", overflowY: "auto" }}
  onChange={(value) => setDocumentType(value)}
  suffixIcon={
    <span style={{ fontSize: "1vw", color: "#1f487c" }}>
      <IoMdArrowDropdown size="2vw" />
    </span>
  }
  style={{ padding: 4 }}
  options={[
    {
      value: "",
      label: <div>All Types</div>,
      search: "All Types",
    },
    { value: "pdf", label: <div>PDF</div>, search: "PDF" },
    {
      value: "sheet",
      label: <div>Spreadsheet</div>,
      search: "Spreadsheet",
    },
    {
      value: "word",
      label: <div>Document</div>,
      search: "Document",
    },
    { value: "image", label: <div>Image</div>, search: "Image" },
    { value: "zip", label: <div>Zip</div>, search: "Zip" },
  ]}
/>
            </ConfigProvider>
          </div>
          {/* Grid / List toggle */}
          <div className="flex items-center border-[#1F487C] border-l-[0.1vw] border-t-[0.1vw] border-r-[0.25vw] border-b-[0.25vw] rounded-[0.5vw] overflow-hidden h-[5vh]">
            <button
              className={`h-full px-[0.75vw] flex items-center justify-center transition-colors ${
                documentView === "list"
                  ? "bg-[#1F487C] text-white"
                  : "bg-white text-[#1F487C]"
              }`}
              onClick={() => setDocumentView("list")}
            >
              <BsList size="1.3vw" />
            </button>
            <button
              className={`h-full px-[0.75vw] flex items-center justify-center transition-colors ${
                documentView === "grid"
                  ? "bg-[#1F487C] text-white"
                  : "bg-white text-[#1F487C]"
              }`}
              onClick={() => setDocumentView("grid")}
            >
              <BsGrid size="1.1vw" />
            </button>
          </div>
          {/* Upload button */}
          <button
            className="bg-[#1F487C] flex items-center justify-center gap-[0.5vw] h-[5vh] px-[1.25vw] rounded-[0.5vw] border-[#1F487C] border-l-[0.1vw] border-t-[0.1vw] border-r-[0.25vw] border-b-[0.25vw] text-white text-[1.1vw] font-bold"
            onClick={() => openDocumentModal("add")}
          >
            <FaPlus size="1vw" />
            Upload
          </button>
        </div>
      );
    }

    if (activeTab === "contacts") {
      return (
        <div className="flex items-center gap-[0.75vw]">
          <div className="umselect">
            <ConfigProvider
              theme={{
                components: {
                  Select: {
                    optionActiveBg: "#aebed1",
                    optionSelectedColor: "#FFF",
                    optionSelectedBg: "#e5e5e5",
                  },
                },
              }}
            >
              <Select
                showSearch
                value={contactCategory}
                dropdownClassName="custom-dropdown"
                className="custom-select bg-white outline-none w-[11vw] h-[5vh] text-[1.1vw] border-[#1F487C] border-l-[0.1vw] border-t-[0.1vw] rounded-[0.75vw] border-r-[0.25vw] border-b-[0.25vw]"
                placeholder="All Categories"
                optionFilterProp="search"
                listHeight={200}
                onChange={(value) => setContactCategory(value)}
                dropdownStyle={{
                     width: "9vw",
                     padding: 0,
                     maxHeight: "25vw",
                     overflow: "hidden",
                }}
                suffixIcon={
                  <span style={{ fontSize: "1vw", color: "#1f487c" }}>
                    <IoMdArrowDropdown size="2vw" />
                  </span>
                }
                style={{ padding: 4 }}
                options={[
                  {
                    value: "",
                    label: <div>All Categories</div>,
                    search: "All Categories",
                  },
                  {
                    value: "Partners",
                    label: <div>Partners</div>,
                    search: "Partners",
                  },
                  {
                    value: "Vendors",
                    label: <div>Vendors</div>,
                    search: "Vendors",
                  },
                  {
                    value: "Auditors",
                    label: <div>Auditors</div>,
                    search: "Auditors",
                  },
                  {
                    value: "Finance",
                    label: <div>Finance</div>,
                    search: "Finance",
                  },
                  {
                    value: "Escalation Matrix",
                    label: <div>Escalation Matrix</div>,
                    search: "Escalation Matrix",
                  },
                ]}
              />
            </ConfigProvider>
          </div>

          <button
            className="bg-[#1F487C] flex items-center justify-center gap-[0.5vw] h-[5vh] px-[1.25vw] rounded-[0.5vw] border-[#1F487C] border-l-[0.1vw] border-t-[0.1vw] border-r-[0.25vw] border-b-[0.25vw] text-white text-[1.1vw] font-bold"
            onClick={() => openContactModal("add")}
          >
            <FaPlus size="1vw" />
            Add Contact
          </button>
        </div>
      );
    }

    if (activeTab === "logs") {
      return (
        <div className="flex items-center gap-[0.75vw]">
          <div className="umselect">
            <ConfigProvider
              theme={{
                components: {
                  Select: {
                    optionActiveBg: "#AEBED1",
                    optionSelectedColor: "#FFF",
                    optionSelectedBg: "#E5E5E5",
                  },
                },
              }}
            >
              <Select // showSearch
                value={logType}
                dropdownClassName="custom-dropdown"
                className="custom-select bg-white outline-none w-[11vw] h-[5vh] text-[1.1vw] border-[#1F487C] border-l-[0.1vw] border-t-[0.1vw] rounded-[0.75vw] border-r-[0.25vw] border-b-[0.25vw]"
                placeholder="All types" // optionFilterProp="search"
                listHeight={200}
                onChange={(value) => setLogType(value)}
                suffixIcon={
                  <span style={{ fontSize: "1vw", color: "#1F487C" }}>
                    <IoMdArrowDropdown size="2vw" />
                  </span>
                }
                style={{ padding: 4 }}
                options={[
                  {
                    value: "activity_logs",
                    label: <div>Activity Logs</div>,
                    search: "Activity Logs",
                  },
                  {
                    value: "access_logs",
                    label: <div>Access Logs</div>,
                    search: "Access Logs",
                  },
                ]}
              />
            </ConfigProvider>
          </div>
        </div>
      );
    }
    return (
      <div className="flex items-center gap-[0.75vw]">
        <button
          onClick={() => {
            setShowLogoutModal(true);
          }}
          className="bg-white h-[5vh] px-[1.2vw] rounded-[0.5vw] text-[#1F487C] border-[#1F487C] border-l-[0.1vw] border-t-[0.1vw] border-r-[0.25vw] border-b-[0.25vw] text-[1vw] font-bold flex items-center gap-[0.4vw]"
        >
          <BiLogOutCircle size="1vw" />
          LogOut
        </button>

        {/* <button className="bg-[#1F487C] h-[5vh] px-[1.25vw] rounded-[0.5vw] text-white border-[#1F487C] border-l-[0.1vw] border-t-[0.1vw] border-r-[0.25vw] border-b-[0.25vw] text-[1.1vw] font-bold flex items-center gap-[0.5vw]">
          <FaPlus size="1vw" />
          Add Item
        </button> */}
      </div>
    );
  };

  return (
    <>
      {isVaultAuthenticated ? (
        <>
          <div
            className="h-screen w-screen blur-0"
            style={{
              backgroundImage: `url(${Backdrop})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="px-[2.5vw] h-[92vh] relative w-full">
              <div className="h-[12vh] w-full flex flex-col">
                <h1 className="text-[#1F487C] pt-[0.5vw] text-[1.5vw] font-bold">
                  SUPER ADMIN VAULT
                </h1>

                <div className="pb-[0.5vw] flex items-center justify-between">
                  <div className="flex items-center gap-x-[2.5vw]">
                    <div className="relative flex items-center">
                      <div
                        className={`flex items-center bg-white placeholder-[#9CA3AF] text-[#1F487C] outline-none pl-[1.75vw] w-[17vw] h-[5vh] text-[1vw] placeholder:text-[1vw] border-[#1F487C] border-l-[0.1vw] border-t-[0.1vw] rounded-[0.75vw] border-r-[0.25vw] border-b-[0.25vw] ${
                          isSearchDisabled
                            ? "opacity-60 cursor-not-allowed"
                            : ""
                        }`}
                      >
                        <input
                          type="text"
                          value={searchValue}
                          disabled={isSearchDisabled}
                          className="w-[13.2vw] outline-none pt-[0.25vw] pl-[0.25vw] disabled:cursor-not-allowed"
                          placeholder={
                            isSearchDisabled ? "Search..." : "Search..."
                          }
                          onKeyDown={handleKeyDown}
                          onChange={(e) => setSearchValue(e.target.value)}
                        />
                      </div>

                      <span className="inline-block cursor-pointer text-[#1F4B7F] text-[1vw] align-text-bottom absolute right-[1vw]">
                        {searchValue ? (
                          <MdCancel
                            size="1.3vw"
                            className="text-[#1f487c] cursor-pointer"
                            onClick={handleClear}
                          />
                        ) : !isSearchDisabled ? (
                          <Popover
                            color="white"
                            title={
                              <div className="text-[#1F4B7F] p-[1vw] max-h-[20vw] overflow-auto">
                                <span className="font-bold">SEARCH BY...</span>
                                {currentSearchInfos.map((info, index) => (
                                  <div key={index} className="flex flex-col">
                                    <ul
                                      className="pl-[1vw]"
                                      style={{ listStyleType: "disc" }}
                                    >
                                      <li className="text-[0.8vw]">
                                        <p>{info.title}</p>
                                      </li>
                                    </ul>
                                  </div>
                                ))}
                              </div>
                            }
                            placement="bottom"
                          >
                            <BsExclamationCircle
                              size="17px"
                              color="#9CA3AF"
                              className="align-middle leading-none mr-[4px] mb-[2px]"
                            />
                          </Popover>
                        ) : null}
                      </span>

                      <LiaSearchSolid
                        className="absolute inline-block left-[0.5vw]"
                        size="1vw"
                        color="#9CA3AF"
                      />
                    </div>

                    <div className="flex items-center gap-x-[3vw]">
                      {tabs.map((tab) => (
                        <div
                          key={tab.key}
                          className={`cursor-pointer outline-none ${
                            activeTab === tab.key
                              ? "border-b-[0.25vw] font-bold border-[#1f487c]"
                              : ""
                          }`}
                          onClick={() => handleTabChange(tab.key)}
                        >
                          <p className="text-[1.3vw] text-[#1f487c] text-center">
                            {tab.label}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>

                  {renderRightActions()}
                </div>
              </div>

              <div
                className={
                  activeTab === "home"
                    ? "h-[78.5vh] overflow-y-auto custom-table-container border-[#1F487C] border-l-[0.1vw] border-t-[0.1vw] border-r-[0.2vw] border-b-[0.2vw] rounded-[1vw] bg-white/35 p-[0.95vw]"
                    : ""
                }
              >
                {renderContent()}
              </div>
            </div>
          </div>

          <ModalPopup
            show={credentialModalOpen}
            onClose={closeCredentialModal}
            height="35vw"
            width="50vw"
            closeicon={false}
          >
            <CredentialForm
              credentialId={credentialId}
              mode={credentialModalMode}
              setModalIsOpen={setCredentialModalOpen}
              onSuccess={handleCredentialSuccess}
              otpPurpose={otpPurpose}
              setOtpPurpose={setOtpPurpose}
              verified={verified}
              setVerified={setVerified}
            />
          </ModalPopup>

          {/* Document Upload/Edit Modal */}
          <ModalPopup
            show={documentModalOpen}
            onClose={closeDocumentModal}
            height="30vw"
            width="42vw"
            closeicon={false}
          >
              
            <DocumentForm
              documentId={documentId}
              mode={documentModalMode}
              setModalIsOpen={setDocumentModalOpen}
              onSuccess={handleDocumentSuccess}
              currentFilter={documentType}
            />
          </ModalPopup>
          <ModalPopup
            show={contactModalOpen}
            onClose={closeContactModal}
            height="35vw"
            width="50vw"
            closeicon={false}
          >
            <ContactForm
              contactId={contactId}
              mode={contactModalMode}
              setModalIsOpen={setContactModalOpen}
              onSuccess={handleContactSuccess}
              currentFilter={contactCategory}
            />
          </ModalPopup>

          <ModalPopup
            show={showLogoutModal}
            onClose={closeLogoutModal}
            // height="30vw"
            // width="30vw"
            closeicon={false}
          >
            <div className="h-full flex flex-col justify-between gap-y-4">
              {/* <h1 className="text-[1.6vw] text-[#1F4B7F] font-semibold text-center">
                Log Out
              </h1> */}
              <p className="text-[1.6vw] text-[#1F4B7F] font-semibold text-center">
                Choose where you'd like to log out.
              </p>
              <div className="border-[#1F4B7F] border-l-[0.1vw] border-t-[0.1vw] border-r-[0.25vw] border-b-[0.25vw] rounded-[0.5vw] p-2 flex flex-col justify-between items-center gap-y-2">
                <p className="text-[1.6vw] text-zinc-700 font-semibold">
                  This device only{" "}
                </p>
                <button
                  className="bg-[#1f4b7f] text-white px-2 py-1 rounded-md shadow-lg"
                  onClick={handleLogOut}
                >
                  Log out
                </button>
                <p className="text-center text-xs">
                  Log out from the device you're currently using. Other devices
                  will remain logged in.
                </p>
              </div>
              <div className="border-[#1F4B7F] border-l-[0.1vw] border-t-[0.1vw] border-r-[0.25vw] border-b-[0.25vw] rounded-[0.5vw] p-2 flex flex-col justify-between items-center gap-y-2">
                <p className="text-[1.6vw] text-zinc-700 font-semibold">
                  All devices
                </p>
                <button
                  className="bg-[#1f4b7f] text-white px-2 py-1 rounded-md"
                  onClick={handleLogOutAll}
                >
                  Log out everywhere
                </button>
                <p className="text-center text-xs">
                  Log out from all devices and browsers where your account is
                  currently active.
                </p>
              </div>
            </div>
          </ModalPopup>
        </>
      ) : (
        <>
          <VaultLoginPage
            setIsVaultAuthenticated={setIsVaultAuthenticated}
            authLoading={loading}
          />
        </>
      )}
    </>
  );
};

export default SuperAdminVault;
